import { render } from "./PersonalPhotography1.vue?vue&type=template&id=968ca1d2&scoped=true"
import script from "./PersonalPhotography1.vue?vue&type=script&lang=js"
export * from "./PersonalPhotography1.vue?vue&type=script&lang=js"

import "./PersonalPhotography1.vue?vue&type=style&index=0&id=968ca1d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-968ca1d2"]])

export default __exports__